import { useCallback, useMemo } from "react";

import { Column, MenuItems, usePopover } from "@bridgesplit/ui";
import { DispatchType } from "@bridgesplit/react";

type RadioRowProps<T> = {
    label: string;
    value: T;
    icon?: JSX.Element;
};

type RadioListProps<T> = {
    selected: T;
    setSelected?: DispatchType<T>;
    onSelect?: (value: T) => void;
    rows: RadioRowProps<T>[];
    showSelected?: boolean;
};
export default function RadioList<T>({
    selected,
    setSelected,
    onSelect,
    rows,
    showSelected = true
}: RadioListProps<T>) {
    const { close } = usePopover();
    const handleClick = useCallback(
        (value: T) => {
            setSelected?.(value);
            onSelect?.(value);
        },
        [setSelected, onSelect]
    );
    const items = useMemo(
        () =>
            rows.map(({ label, value, icon }) => ({
                text: label as string,
                icon,
                selected: showSelected && selected === value,
                onClick: () => handleClick(value),
                disableClose: true
            })),
        [rows, selected, showSelected]
    );

    return (
        <Column spacing={0.5} role="radiogroup">
            <MenuItems items={items} close={close} />
        </Column>
    );
}
